<template>
  <v-container>
    <v-row>
      <v-col sm="10">
        <h4 class="white--text">Total saved items</h4>
      </v-col>
      <v-col sm="2">
        <div
          :class="{ paddingT10: totalItemToggle }"
          @click="totalItemToggle = !totalItemToggle"
        >
          <v-icon
            class="cursorPointer"
            color="white"
            size="25"
            v-if="!totalItemToggle"
            :data-test-id="`${dataTestId}__open-icon`"
            >add</v-icon
          >
          <v-icon
            class="cursorPointer"
            color="white"
            size="25"
            v-if="totalItemToggle"
            :data-test-id="`${dataTestId}__close-icon`"
            >maximize</v-icon
          >
        </div>
      </v-col>
    </v-row>
    <transition name="slideUp">
      <v-row class v-if="totalItemToggle">
        <v-col sm="6" class="pr-0 mr-0">
          <h1 class="item-count white--text">
            {{ projectDetails ? projectDetails.archiveIds : 0 }}
          </h1>
        </v-col>
        <v-col
          sm="6"
          class="text-right pl-0 ml-0"
          v-if="showOrHide(projectDetails)"
        >
          <v-btn
            color="#1B2342"
            small
            :ripple="false"
            class="white--text"
            v-if="
              projectDetails.projectStatus !==
                this.$enums.projectStatus.ARCHIVED
            "
            @click.stop="confirmation = true"
            :data-test-id="`${dataTestId}__view-all-saved-items-btn`"
            >View all</v-btn
          >
        </v-col>
      </v-row>
    </transition>
    <x-dialog
      :confirmDialog="true"
      :dialogState="confirmation"
      :dialogTitle="'Confirm?'"
      :dialogText="'This will clear any of your search results. Continue?'"
      @toggleModal="closeDialog"
      :actions="{
        show: true,
        secondaryButtonFunction: closeDialog,
        primaryButtonFunction: viewProjectArchives,
        primaryButtonShow: true,
        secondaryButtonText: 'Cancel',
        primaryButtonText: 'Confirm'
      }"
      :data-test-id="`${dataTestId}__confirm-dialog`"
    />
  </v-container>
</template>

<script>
import EventBus from '@/EventBus';

export default {
  data() {
    return {
      totalItemToggle: true,
      confirmation: false
    };
  },
  props: {
    projectDetails: Object,
    dataTestId:String
  },
  mounted() {
    EventBus.$on('OPEN_DIALOGUE', cancelled => {
      this.confirmation = cancelled;
    });
  },
  methods: {
    showOrHide(details) {
      if (!details) {
        return false;
      }
      return !!details.archiveIds;
    },
    closeDialog() {
      this.confirmation = false;
    },
    viewProjectArchives() {
      this.confirmation = false;
      let targetPath =
        '/discovery/projects/' + this.$route.params.projectId + '/archives/p1';
      if (this.$route.path === targetPath) {
        return;
      }
      this.$router.push({
        path: targetPath
      });
    }
  },
  beforeDestroy() {
    EventBus.$off('OPEN_DIALOGUE');
  }
};
</script>
